import * as React from 'react';

import EmailNotification16 from './EmailNotification16';

export const emailNotification16 = () => <EmailNotification16 />;

export default {
    title: 'Icon/Fill/EmailNotification16',
    component: EmailNotification16,
    parameters: {
        notes: "`import EmailNotification16 from 'box-ui-elements/es/icon/fill/EmailNotification16';`",
    },
};
